import React from 'react';
import { useHistory } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';

import './style.scss';
import useIsComDomain from '@src/hooks/useIsComDomain';

import TabBar from '@src/componentsNew/TabBar';
import MobileNewFlashSale from '@src/componentsNew/ProductList/NewFlashSale/MobileNewFlashSale';
import MobileEditorsPick from '@src/componentsNew/ProductList/EditorsPick/MobileEditorsPick';
import MobileNewProducts from '@src/componentsNew/ProductList/NewProducts/MobileNewProducts';
import MobileMainNewMGS from '@src/componentsNew/ProductList/MainNewMGS/MobileMainNewMGS';
import MobileHomeOffers from '@src/componentsNew/Offers/MobileHomeOffers';
import MobileComMainCollection from '@src/componentsNew/ProductList/ComMainCollection/MobileComMainCollection';

import { baseUrl, offersUrl, mobileMainMgsTabUrl } from '@src/app/routes';

const tabItems = [
  { name: 'For You', url: baseUrl },
  { name: 'Offers', url: offersUrl },
  { name: 'MGS', url: mobileMainMgsTabUrl },
];

function MobileHome() {
  const history = useHistory();
  const isComDomain = useIsComDomain();

  const { ref: editorsPickRef, inView: editorsPickInView } = useInView({
    threshold: 0.3,
    triggerOnce: true,
  });

  const handleTabChange = (event, newValue) => {
    history.push(tabItems[newValue].url);
  };

  return (
    <section className="mobile-home-section">
      {isComDomain ? (
        <>
          <MobileNewProducts />

          {process.env.ENVIRONMENT === 'production' && process.env.COM_MAIN_MOST_POPULAR_COLLECTION_ID && (
            <MobileComMainCollection />
          )}

          <MobileHomeOffers />
        </>
      ) : (
        <>
          <TabBar tabItems={tabItems} selectedTab={0} onTabChange={handleTabChange} />

          <MobileNewFlashSale />

          <MobileEditorsPick ref={editorsPickRef} />

          {process.env.ENVIRONMENT === 'production' && process.env.NEW_ARRIVAL_MGS_COLLECTION_ID && (
            <MobileMainNewMGS />
          )}

          {editorsPickInView && (
            <>
              <MobileNewProducts />

              <MobileHomeOffers />
            </>
          )}
        </>
      )}
    </section>
  );
}

export default MobileHome;
